import { Pagination } from "antd";
import { PaginationWrap } from "./style";

export default ({ total, defaultPageSize, defaultCurrent, onChange }) => {
  return (
    <PaginationWrap>
      <Pagination
        total={total}
        onChange={onChange}
        defaultCurrent={defaultCurrent}
        defaultPageSize={defaultPageSize}
        showSizeChanger={false}
      />
    </PaginationWrap>
  );
};
